export enum AutoConflictResolution {
  Overwrite,
  Skip,
  Ask,
}
/**
 * Настройка того, как будет себя вести функция копирования/перемещения
 * Overwrite: перезаписывать
 * Ask: спрашивать
 * NoOverwrite: не перезаписывать и фейлиться
 */
export enum OverwriteSetting {
  Overwrite,
  Ask,
  NoOverwrite,
}
export enum UserDecisionConflictResolution {
  Overwrite,
  Skip,
  OverwriteAll,
  SkipAll,
}

export type ConflictResolverShape = {
  currentFileName: string | null;
  autoResolve: AutoConflictResolution;
};
